<script>
  import { Router, Route, Link, router, navigateTo } from "yrv";  
  import Nav from "./components/Nav.svelte";
  import Home from "./components/Home.svelte";
  import About from "./components/About.svelte";
  import Page from "./components/Page.svelte";
  import ProfilePage from "./components/ProfilePage.svelte";
  import { onMount, tick } from "svelte";
  import UserMaps from "./components/UserMaps.svelte";
  import Profile from "./components/Profile.svelte";
  import GetMap from "./components/GetMap.svelte";
  import Loader from "./components/Loader.svelte";
  import { auth, googleProvider } from "./firebase";
  import { authState } from "rxfire/auth";
  import Login from "./components/Login.svelte";
  import {getContext} from "svelte";
  import Tailwindcss from "./Tailwindcss.svelte";
  import GalleryTest from "./components/GalleryTest.svelte";


  let user;

  const unsubscribe = authState(auth).subscribe(u => (user = u));

  $: getUserId = user ? user.uid : false

  function login() {
    navigateTo("/#login");
    auth.signInWithPopup(googleProvider);
  }


  function logOut() {
    auth
      .signOut()
      .then(function() {
        console.log("Sign-out successful");
        navigateTo("/");
      })
      .catch(function(error) {
        console.log("Error signing out");
      });
  }


  const openProfileModal = ()=> {
    // open(Profile);
  }


  /* global USE_HASH_CHANGE */
  if (typeof USE_HASH_CHANGE !== "undefined" && USE_HASH_CHANGE) {
    Router.hashchange = USE_HASH_CHANGE;
  }

  let mounted = false;

  onMount(() => {
    mounted = true;
  });


</script>

<style>
  :global(button.button) {
    @apply border rounded-md py-2 px-4 cursor-pointer;
  }
</style>

<Tailwindcss/>



<Nav>
  <div slot="profile">
    {#if user}
      <div>
        <Profile uid=user.uid photoURL={user.photoURL} displayName={user.displayName}  />
      </div>
    {/if}
  </div>
</Nav>



<Router>

  <!-- About -->
  <Route exact path="/#about" let:router>
    <Page fullwidth={false}>
      <About />
    </Page>
  </Route>
  <!-- List of Maps -->
  <Route exact let:router>
    <Page>
      
      {#if user}      
        <UserMaps uid={user.uid} email={user.email} />
      {:else}
        <div class="max-w-screen-sm rounded-xl bg-gray-100 m-auto p-12 mt-12">
          <h1 class="text-5xl text-black font-bold">Sign in with your Google Account.</h1>
          <p class="mt-8">Create a journey map repository to help you improve customer's experiences with your products.</p>
          <div class="mt-8 cursor-pointer" on:click={login}><img src="/google-sign-in.png"/></div>
        </div>
      {/if}
    </Page>
  </Route>

  <Route exact path="/#maps/:mapid" let:router>
    <Page>
      <GetMap uid={getUserId} mapid={router.params.mapid} />
    </Page>
  </Route>

  <Route exact path="/#login" let:router>
    <Login/>
  </Route>
  <Route exact path="/#gallery" >
    <GalleryTest/>
  </Route>

  <Route exact path="/#profile" let:router>
    <Page fullwidth={false}>    
            
    {#if user}
      <h1 class="text-2xl font-bold mb-4">Your Profile</h1>
      <p>Signed in with Google account:</p> 
      <div class="flex items-center space-x-4 mt-4">
        <Profile uid=user.uid photoURL={user.photoURL} displayName={user.displayName} width="100"  />
        <div>
        <div class="font-bold text-lg">{user.displayName}</div>
        <div>{user.email}</div>
        </div>
        

      </div>
      <p class="mt-8">
        <button
        class="border rounded-lg px-4 py-2 bg-white text-sm text-white bg-mapblue hover:border-black"
        on:click={logOut}>Sign Out</button
      >
      </p>      
    {:else}
      <button class="button" on:click={login}>
        <span>Sign in with Google</span>
      </button>
    {/if}
    
    </Page>
  </Route>

  <Route fallback let:router>
    <Page>
      <h1>Can't find this page. {router.path}</h1>
    </Page>
  </Route>

</Router>
